import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const CtaSection = () => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="relative py-24 px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=elegant%20luxury%20interior%20design%20living%20space%20Abidjan%20Ivory%20Coast%20Africa%20warm%20ambient%20lighting%20modern%20sophisticated%20decor%20gold%20accents%20beautiful%20upscale%20apartment&width=1920&height=600&seq=evco_cta001&orientation=landscape"
          alt="Ev & Co Design studio"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-brand-anthracite/75" />
      </div>
      <div
        ref={ref}
        className={`relative z-10 max-w-3xl mx-auto text-center transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      >
        <div className="inline-flex items-center gap-2 mb-6">
          <span className="h-px w-6 bg-brand-gold" />
          <span className="text-brand-gold text-xs font-medium tracking-[0.2em] uppercase">Votre projet nous attend</span>
          <span className="h-px w-6 bg-brand-gold" />
        </div>
        <h2 className="font-serif text-4xl lg:text-5xl text-white leading-tight mb-6">
          Prêt à transformer votre <em className="text-brand-coral">vision</em> en réalité ?
        </h2>
        <p className="text-white/80 text-lg mb-10 leading-relaxed">
          Contactez-nous pour une consultation personnalisée et découvrez comment Ev&amp;Co Design peut sublimer votre espace ou événement.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact#contact-form"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full text-white font-medium text-sm whitespace-nowrap transition-all duration-300 hover:scale-105"
            style={{ background: 'linear-gradient(135deg, #e63e8b, #f78b49)' }}
          >
            <i className="ri-mail-send-line" />
            Demander un devis
          </Link>
          <Link
            to="/decoration-interieur"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full border border-white/40 text-white font-medium text-sm whitespace-nowrap transition-all duration-300 hover:bg-white/10"
          >
            <i className="ri-phone-line" />
            Nous contacter
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
